import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'forgot'},
  { path: 'forgot',
    loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule) },
  { path: 'reset/user/password/recover',
    loadChildren: () => import('./reset-password/reset-password.module').then(m => m.ResetPasswordModule) },
  // unused { path: '**', component: NotFoundComponent, },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
